import { useEffect, useState } from 'react';
import { SelectOption } from './ui/Select';
import { GOOGLE_WEB_FONTS } from './pixiLogoApp/constants';
import { getQueryParamByName } from '@Utils/shared/utils/getQueryParamByName';

import apiFetch from '@wordpress/api-fetch';

import { allIcons } from '../../data/logoMakerIcons';
import * as logoMakerFrames from '../../data/logoMakerFrames';
import * as logoMakerShapes from '../../data/logoMakerShapes';
import logoMakerBackgrounds from '../../data/logoMakerBackgrounds';

export enum LogoMakerAssets {
  Icons = 1,
  Frames = 2,
  Shapes = 3,
  Patterns = 4,
}

interface GalleryLogos {
  orderId: number;
  categoryId: number;
  config: Object; // TODO: define this type fully
  mainImageAlt: string;
}

export interface GalleryCategories {
  id: number;
  title: string;
}

export interface GalleryLogosAndCategories {
  categories: GalleryCategories[];
  logos: GalleryLogos[];
}

interface ApiResponse {
  errors?: { message: string }[];
  [key: string]: any;
}

const newFont = (() => {
  let id = 0;
  return (name: string) => ({
    id: id++,
    label: name,
    value: name,
  });
})();

export const fonts = GOOGLE_WEB_FONTS.map((n) => newFont(n));

/**
 * Fetches assets for the Logo Maker
 *
 * @param {number} type The type of assets to fetch
 * @returns {Promise<string[]>} Array of asset URLs
 */
async function fetchLogoMakerAssets(type: LogoMakerAssets): Promise<string[] | any> {
  switch (type) {
    case 1:
      return allIcons;
    case 2:
      return Object.values(logoMakerFrames);
    case 3:
      return Object.values(logoMakerShapes);
    case 4:
      return logoMakerBackgrounds;
    default:
      return;
  }
}

function transformAssets(assets: string[]): SelectOption[] {
  return assets.map((value, index) => ({
    value,
    label: `${index}`,
    id: index,
  }));
}

export function useLogoMakerApi(type: LogoMakerAssets) {
  const [assets, setAssets] = useState<string[]>([]);

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        setAssets(await fetchLogoMakerAssets(type));
      } catch (error) {
        console.error(error);
      }
    };

    fetchAssets();
  }, [type]);

  return transformAssets(assets);
}

function getServerFromUrl() {
  return getQueryParamByName('server');
}

export async function checkPlayerId(userId: string) {
  const server = getServerFromUrl();
  const apiUrl = server
    ? `/plarium-mini-apps/v1/raid/id/validate/?server=${server}`
    : '/plarium-mini-apps/v1/raid/id/validate';

  const data: ApiResponse = await apiFetch({
    path: apiUrl,
    method: 'POST',
    data: {
      id: userId,
    },
  });

  return data;
}
